export class Tracking {
    entry_date: Date;
    entry_date_string: string;
    leave_date: Date;
    leave_date_string: string;
    duration: number;  
}